var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoLiteTooltips(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "0 0 32 32",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.933 22.6c0 .736-.596 1.333-1.333 1.333h-3.2a1.333 1.333 0 0 1 0-2.667h3.2c.736 0 1.333.597 1.333 1.333M17.467 9.4c0 .736-.597 1.333-1.333 1.333h-.267a1.333 1.333 0 0 1 0-2.667h.267c.736 0 1.333.597 1.333 1.334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.667 15.134H14.4a1.333 1.333 0 0 1 0-2.667h.8c1.178 0 2.133.955 2.133 2.133v6.667a1.333 1.333 0 1 1-2.666 0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.168 0 0 7.168 0 16s7.168 16 16 16 16-7.168 16-16S24.832 0 16 0m0 28.8C8.944 28.8 3.2 23.056 3.2 16S8.944 3.2 16 3.2 28.8 8.944 28.8 16 23.056 28.8 16 28.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLiteTooltips);
export default __webpack_public_path__ + "static/media/IcoLiteTooltips.5ce487852c7a05da899679525ed2b412.svg";
export { ForwardRef as ReactComponent };